import { combineReducers } from 'redux';
import { companyReducer } from './Company/reducer';

export const settingsReducer = combineReducers({
  company: companyReducer,
});
